module.exports = __webpack_public_path__ + "static/animation-map-pin4-d3c36ce67ddd4524baeb33c7e55f69be.png";